"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchActivities = exports.StravaActivityType = void 0;
const mithril_1 = __importDefault(require("mithril"));
var StravaActivityType;
(function (StravaActivityType) {
    StravaActivityType["AlpineSki"] = "AlpineSki";
    StravaActivityType["BackcountrySki"] = "BackcountrySki";
    StravaActivityType["Canoeing"] = "Canoeing";
    StravaActivityType["Crossfit"] = "Crossfit";
    StravaActivityType["EBikeRide"] = "EBikeRide";
    StravaActivityType["Elliptical"] = "Elliptical";
    StravaActivityType["Hike"] = "Hike";
    StravaActivityType["IceSkate"] = "IceSkate";
    StravaActivityType["InlineSkate"] = "InlineSkate";
    StravaActivityType["Kayaking"] = "Kayaking";
    StravaActivityType["Kitesurf"] = "Kitesurf";
    StravaActivityType["NordicSki"] = "NordicSki";
    StravaActivityType["Ride"] = "Ride";
    StravaActivityType["RockClimbing"] = "RockClimbing";
    StravaActivityType["RollerSki"] = "RollerSki";
    StravaActivityType["Rowing"] = "Rowing";
    StravaActivityType["Run"] = "Run";
    StravaActivityType["Snowboard"] = "Snowboard";
    StravaActivityType["Snowshoe"] = "Snowshoe";
    StravaActivityType["StairStepper"] = "StairStepper";
    StravaActivityType["StandUpPaddling"] = "StandUpPaddling";
    StravaActivityType["Surfing"] = "Surfing";
    StravaActivityType["Swim"] = "Swim";
    StravaActivityType["VirtualRide"] = "VirtualRide";
    StravaActivityType["Walk"] = "Walk";
    StravaActivityType["WeightTraining"] = "WeightTraining";
    StravaActivityType["Windsurf"] = "Windsurf";
    StravaActivityType["Workout"] = "Workout";
    StravaActivityType["Yoga"] = "Yoga";
})(StravaActivityType = exports.StravaActivityType || (exports.StravaActivityType = {}));
function fetchActivities(access_token, onProgress, per_page = 50, after) {
    return __awaiter(this, void 0, void 0, function* () {
        let actData = [];
        let page = 1;
        let actDataBatch;
        do {
            actDataBatch = yield mithril_1.default.request({
                url: `https://www.strava.com/api/v3/athlete/activities?per_page=${per_page}&page=${page}` + (after ? `&after=${after}` : ''),
                headers: { 'Authorization': `Bearer ${access_token}` },
            });
            actData.push(...actDataBatch);
            page++;
            onProgress && onProgress(actData.slice());
        } while (actDataBatch.length === per_page);
        return actData;
    });
}
exports.fetchActivities = fetchActivities;
// NOTE: { 'Accept': 'application/json+meta' } can be used to return a big list of IDs
